<template>
    <BreadCrumb PageTitle="Modifier" />
    <EditChefquartier/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditChefquartier from "@/components/Assignations/EditChefquartier.vue";
  
    export default defineComponent({
      name: "EditChefquartierPage",
      components: {
        BreadCrumb,
        EditChefquartier,
      },
    });
  </script>